import { Field, Formik } from "formik";
import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Input, Select } from "../../../../../../_metronic/_partials/controls";
import * as Yup from "yup";
import { checkExistingOrg } from "../../../_redux/library/libraryCrud";
import { SIMPZ_STATUS_ARRAY } from "../LibraryUIHelpers";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";

const validationSchema = Yup.object({
  name: Yup.string().required("Nama folder tidak boleh kosong!")
});

export default function LibraryCreateForm({ onSubmit, defaultValues }) {
  return (
    <Formik
      initialValues={defaultValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ setFieldValue, handleSubmit, values }) => (
        <>
          <div className="form-group row">
            <div className="col">
              <Field
                name="name"
                label="Nama Folder"
                component={Input}
                placeholder="Masukkan nama folder"
              />
            </div>
          </div>
          {values.check_sharing && <div className="form-group row justify-content-center">
            <div className="col ">
              <textarea
                className="form-control"
                name="description"
                label="Deskripsi"
                component={Input}
                onChange={(e) => setFieldValue('description', e.target.value)}
                placeholder="Masukkan deskripsi folder"
              />
            </div>
          </div>}
          <div className="form-group row justify-content-center">
            <div className="col ">
              <Field
                className="mr-2"
                type="checkbox"
                name="check_sharing"
                label="Folder Sharing"
              />
              <label className="p-0 m-0">Folder Sharing</label>
            </div>
          </div>

          {/* <div className="form-group row">
            <div className="col">
              <label>
                <strong>Deskripsi</strong>
              </label>
              <textarea
                name="description"
                placeholder="Deskripsi"
                className="form-control"
                value={values.description}
                onChange={e => setFieldValue("description", e.target.value)}
              />
            </div>
          </div> */}
          <button
            className="btn btn-primary float-right"
            onClick={ () => {
              if (values.check_sharing && !values.description) {
                return toast.error("Deskripsi folder tidak boleh kosong!", toastOption);
              }

              handleSubmit();
            }
              
            }
          >
            Simpan
          </button>
        </>
      )}
    </Formik>
  );
}
